// extracted by mini-css-extract-plugin
export default {"appLayout":"layout_appLayout__a8xZT","mainContent":"layout_mainContent__IQno+","sidebarExpanded":"layout_sidebarExpanded__rNwbA","sidebarCollapsed":"layout_sidebarCollapsed__WJUpa"};